import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';


const VALID_TABS = ['locations', 'assignLocation', 'assigned'] as const;

type CheckInLocationTab = typeof VALID_TABS[number];

function isValidTab(id: string): id is CheckInLocationTab {
  return (VALID_TABS as readonly string[]).includes(id);
}

export interface UseCheckInLocationPageResult {
  activeTab: CheckInLocationTab;
  handleBackClick: () => void;
  handleTabChange: (id: string) => void;
}

export function useCheckInLocationPage(): UseCheckInLocationPageResult {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<CheckInLocationTab>('locations');

  const handleBackClick = useCallback(() => {
    void navigate(-1);
  }, [navigate]);

  const handleTabChange = useCallback((id: string) => {
    if (isValidTab(id)) {
      setActiveTab(id);
    }
  }, []);

  return {
    activeTab,
    handleBackClick,
    handleTabChange,
  };
}
